import { createTypes } from 'reduxsauce'
 
export default createTypes(`
  LOGIN_REQUEST
  LOGIN_SUCCESS
  LOGIN_FAILURE
 
  CHANGE_PASSWORD
  CHANGE_PASSWORD_SUCCESS
  CHANGE_PASSWORD_FAILURE

  SET_VIGNET_NUMBER
 
  LOGOUT
`, {});
